"use client";

import Link from "next/link";
import type { ReactNode } from "react";
import { trackEvent } from "@/lib/analytics/track-client";

/**
 * A blog CTA link that records a named conversion event.
 *
 * Until now these were plain <Link>s, so the only record of a blog reader
 * reaching /templates was PostHog autocapture — matched by button TEXT, which
 * cannot tell two same-labelled CTAs apart and breaks silently whenever the
 * copy changes. This emits an explicit event tied to the source post, landing
 * in our own analytics_events table alongside the invitation-side tracking.
 */
export default function TrackedCTALink({
  href,
  placement,
  fromPost,
  className,
  children,
}: {
  href: string;
  /** Where on the page this CTA sits — sidebar card, end-of-article block, inline. */
  placement: string;
  /** Slug of the post the click came from, so conversion is attributable per post. */
  fromPost: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Link
      href={href}
      className={className}
      onClick={() =>
        trackEvent({
          event_type: "blog_cta_click",
          payload: { placement, from_post: fromPost, to: href },
        })
      }
    >
      {children}
    </Link>
  );
}
